<template>
  <div class="wrapp-stores-list">
    <div class="wrapp-stores-list__content">
      <div class="wrapp-stores-list__content__list">
        <slot name="firstOfList" />
        <template v-for="store in stores">
          <card-store :key="store.code" :store="store"></card-store>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import CardStore from './CardStore'
export default {
  name: 'StoresList',
  props: {
    stores: {
      type: Array,
      required: true
    }
  },
  components: {
    CardStore
  }
}
</script>
